// utils/productNomenclature.js

export const buildModelNumber = ({ productConfig, configSetting = [], attributeDetails = [] }) => {
    const matchedProductId = productConfig?.productName?.productId;
    if (!matchedProductId) return "";

    const productAttrRows = attributeDetails.filter(
        (row) => row.productId === matchedProductId
    );

    if (productAttrRows.length === 0) {
        return productConfig?.productName?.nomencleature || "";
    }

    const groupSeqMap = {};
    productConfig?.productName?.productSpecGroupMaps?.forEach((g) => {
        groupSeqMap[g.groupId] = g.sequence;
    });

    const uniqueAttrs = [];
    const seen = new Set();
    [...productAttrRows]
        .sort((a, b) => {
            const groupDiff = (groupSeqMap[a.groupId] ?? 0) - (groupSeqMap[b.groupId] ?? 0);
            if (groupDiff !== 0) return groupDiff;
            return (a.sequenceAttribute ?? 0) - (b.sequenceAttribute ?? 0);
        })
        .forEach((row) => {
            if (!seen.has(row.attributeId)) {
                seen.add(row.attributeId);
                uniqueAttrs.push(row);
            }
        });

    const codes = uniqueAttrs.map((attr) => {
        const userSelection = configSetting.find((c) => c.attributeId === attr.attributeId);
        const selectedValueName = userSelection?.valueName || attr.valueName;

        const matchedRow =
            productAttrRows.find(
                (row) => row.attributeId === attr.attributeId && row.valueName === selectedValueName
            ) || attr;

        return matchedRow?.nomenclature || "";
    });

    const joined = codes.join("");
    return joined || productConfig?.productName?.nomencleature || "";
};
